
const LoadingAnimation = () => {
  return (
    <div className="loading">
      <h2>Planning your route</h2>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}

export default LoadingAnimation